import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { useSEO } from "@/lib/seo";

export default function Contact() {
    useSEO({
        title: "Contact Chesterton",
        description:
            "Reach Chesterton by email or phone. Estate planning, real estate, and business law counsel.",
        path: "/contact"
    });

    return (
        <>
            <section className="bg-acre-bg">
                <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 pt-16 lg:pt-24 pb-12">
                    <div className="flex items-center mb-6">
                        <span className="acre-tick" />
                        <span className="text-[11px] uppercase tracking-[0.28em] text-acre-muted">
                            Engagement Inquiries
                        </span>
                    </div>
                    <h1 className="font-serif-display text-5xl lg:text-7xl leading-[0.98] tracking-tight text-acre-secondary max-w-3xl">
                        Start with a note. <em className="not-italic">The first conversation is on us.</em>
                    </h1>
                    <p className="mt-7 max-w-2xl text-base lg:text-lg leading-relaxed text-acre-muted">
                        Reach us directly by email or phone. We ordinarily respond within one business day with next steps or a time to talk.
                    </p>
                </div>
            </section>

            <section className="pb-24 lg:pb-32 bg-acre-bg">
                <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
                    <div
                        data-testid="contact-panel"
                        className="bg-acre-primary text-white p-10 lg:p-16 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16"
                    >
                        <div className="lg:col-span-7 space-y-10">
                            <div>
                                <div className="text-[10px] uppercase tracking-[0.3em] text-white/70 mb-4 flex items-center gap-3">
                                    <Mail size={12} /> Email
                                </div>
                                <a
                                    href="mailto:info@chesterton.law"
                                    data-testid="contact-email-direct"
                                    className="group font-serif-display text-4xl lg:text-6xl leading-[1] inline-flex items-baseline gap-3 !text-white hover:!text-acre-accentTan transition-colors break-all"
                                >
                                    info@chesterton.law
                                    <ArrowUpRight
                                        size={28}
                                        className="translate-y-1 opacity-70 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-0 transition-all duration-300"
                                    />
                                </a>
                            </div>

                            <div>
                                <div className="text-[10px] uppercase tracking-[0.3em] text-white/70 mb-4 flex items-center gap-3">
                                    <Phone size={12} /> Phone
                                </div>
                                <a
                                    href="tel:+19016412532"
                                    data-testid="contact-call-direct"
                                    className="font-serif-display text-3xl lg:text-4xl !text-white hover:!text-acre-accentTan transition-colors"
                                >
                                    (901) 641-2532
                                </a>
                            </div>
                        </div>

                        <div className="lg:col-span-5 lg:border-l lg:border-white/15 lg:pl-12 space-y-8">
                            <div>
                                <div className="text-[10px] uppercase tracking-[0.3em] text-white/70 mb-3">Response Time</div>
                                <p className="text-sm text-white/85 leading-relaxed">
                                    Messages are ordinarily returned within one business day.
                                </p>
                            </div>
                            <div>
                                <div className="text-[10px] uppercase tracking-[0.3em] text-white/70 mb-3">Practice</div>
                                <p className="text-sm text-white/85 leading-relaxed">
                                    Estate Planning · Real Estate · Business Law. Tennessee counsel, thoughtfully delivered.
                                </p>
                            </div>
                            <p className="text-xs text-white/60 leading-relaxed pt-6 border-t border-white/15">
                                Contacting Chesterton by email or phone does not create an attorney–client relationship. Please do not share confidential information until such a relationship is established.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
